import { defineComponent as _defineComponent } from 'vue'
import BaseDialog from "@/components/base-dialog.vue";
import { ref, computed } from "vue";
import useHttpRequest from "@/composables/use-http-request";
import CourseUnit from "@/interfaces/course-unit.interface";
import store from "@/store";
//@ts-ignore
import nestedGroupby from "nested-groupby";


export default /*#__PURE__*/_defineComponent({
  __name: 'my-module-dialog',
  props: {
    isVisible: { type: Boolean },
    onRefresh: null,
    onClose: null
  },
  setup(__props: any) {

const props = __props as {
  isVisible: boolean;
  onRefresh: () => void;
  onClose: () => void;
}



const loading = ref(false);
const input = ref("");
const semCourseUnits = ref<CourseUnit[]>([]);
const selectedCourseUnitIds = ref([] as string[]);

const clearInputs = () => {
  input.value = "";
};

const closeDialog = () => {
  clearInputs();
  props.onClose();
};

const fetchCourseUnitsForSelection = async () => {
  const request = await useHttpRequest<{
    success: boolean;
    message: string;
    course_units: CourseUnit[];
  }>({
    method: "GET",
    url: `students/fetch-course-units-for-selection-current-semester/${store.state.userId}`,
    loadingProperty: loading,
  });
  if (!request) return;
  if (
    request.success &&
    request.message == "STUDENT_COURSE_UNITS_FETCHED_SUCCESSFULLY"
  ) {
    semCourseUnits.value = request.course_units;
    selectedCourseUnitIds.value = semCourseUnits.value.flatMap((item) => {
      return item.is_selected ? [item.course_unit_id] : [];
    });
  } else {
    closeDialog();
  }
};

const onSaveStudentModules = async () => {
  //Only keep course units that are not locked i.e is_locked == false
  const selectedCourseUnits = selectedCourseUnitIds.value.filter(
    (courseUnitId) => {
      return semCourseUnits.value.some((courseUnit) => {
        return (
          courseUnit.course_unit_id == courseUnitId && !courseUnit.is_locked
        );
      });
    }
  );
  const request = await useHttpRequest<{ success: string; message: string }>({
    method: "POST",
    url: `students/save-course-units-for-semester/${store.state.userId}`,
    loadingProperty: loading,
    showSuccessMessage: true,
    body: {
      selected_course_units: selectedCourseUnits,
    },
  });
  if (!request) return;
  if (request.success && request.message == "Course Units successfully saved") {
    closeDialog();
    props.onRefresh();
  }
};

const formattedCourseUnits = computed(() => {
  return nestedGroupby(semCourseUnits.value, [
    "year_of_study",
    "semester_of_study",
  ]);
});

return { __sfc: true,props, loading, input, semCourseUnits, selectedCourseUnitIds, clearInputs, closeDialog, fetchCourseUnitsForSelection, onSaveStudentModules, formattedCourseUnits, BaseDialog }
}

})